import { render, staticRenderFns } from "./NewsCategoryTag.vue?vue&type=template&id=f726a52c&"
import script from "./NewsCategoryTag.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports